import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import { AlertContext } from "../../../context/AlertContext";
import { ServiciosContext } from "../../../context/ServiciosContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import { ThemeProvider, createMuiTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/material/styles";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import Spinner from "./../Spinner";
import { AuthContext } from "../../../context/AuthContext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import ButtonMui from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Navigate, useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import Menu from "./../Menu";
import { InputNumber } from "primereact/inputnumber";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { InputMask } from "primereact/inputmask";
import IconButton from "@mui/material/IconButton";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const exportColumnsListado = [
  { title: "Nº Afiliado.", dataKey: "id_titular" },
  { title: "Nombre/Razón Social", dataKey: "nombre_razonsocial" },
  { title: "Domicilio", dataKey: "domicilio" },
  { title: "Localidad", dataKey: "localidad" },
  { title: "Grupo", dataKey: "grupo" },
  { title: "Rubro", dataKey: "rubro" },
  { title: "Plan", dataKey: "plan" },
  { title: "Empresa", dataKey: "empresa" },
  { title: "Asesor", dataKey: "asesor" },
  { title: "Cobrador", dataKey: "cobrador" },
  { title: "Vigencia", dataKey: "vigencia" },
  { title: "Cuota", dataKey: "cuota" },
];

const exportColumnsAgrupado = [
  { title: "Descripción", dataKey: "descripcion" },
  { title: "Grupos", dataKey: "grupos" },
  { title: "Cápitas", dataKey: "capitas" },
  { title: "Cuotas", dataKey: "cuotas" },
];

const agrupar = [
  {
    id: 1,
    nombre: "Plan",
  },
  {
    id: 2,
    nombre: "Rubro",
  },
  {
    id: 3,
    nombre: "Grupo",
  },
  {
    id: 4,
    nombre: "Cobrador",
  },
  {
    id: 5,
    nombre: "Asesor",
  },
  {
    id: 6,
    nombre: "Empresa",
  },
];

export default function ListadosCartera(props) {
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const [visibleFechas, setVisibleFechas] = useState(true);
  const [fechas, setFechas] = useState(null);
  const [grupo, setGrupo] = useState(null);
  const [incluyeIntegrantes, setIncluyeIntegrantes] = useState(false);
  const [todasLasEmpresas, setTodasLasEmpresas] = useState(false);
  const [vigencia, guardarVigencia] = useState({
    desde: null,
    hasta: null,
  });
  const toast = useRef(null);

  let navigate = useNavigate();

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    statusAcceso,
    empresaElegida,
    listadoExcel,
    obtenerAcceso,
    obtenerCarteraAltas,
  } = configuracionContext;

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "ListadosCartera",
      });
    }
  }, [state.id]);

  function formatDate(input) {
    var datePart = input.match(/\d+/g),
      year = datePart[0],
      month = datePart[1],
      day = datePart[2];
    return day + "/" + month + "/" + year;
  }

  const startClick = (e) => {
    setTimeout(() => {
      navigate(`/listadoscartera`);
      setVisibleFechas(true);
    }, 2000);
  };

  const exitClick = (e) => {
    navigate("/");
  };

  const onHideFechas = (e) => {
    setVisibleFechas(false);
  };

  const aceptarFechas = async (exportType) => {
    //e.preventDefault();
    //Validar

    if (
      (vigencia.desde !== null && vigencia.hasta === null) ||
      (vigencia.desde === null && vigencia.hasta !== null)
    ) {
      mensajeAlerta(
        "Listados de Cartera",
        "Si especifica un período, debe indicar desde y hasta !.",
        "error",
      );
      return;
    }

    /*
    if ((!grupo || grupo === null) && state.usuario.role !== "a") {
      mensajeAlerta(
        "Listados de Cartera",
        "El listado de cartera detallado esta inhabilitado !.",
        "error",
      );
      return;
    }
    */  

    var elem;

    toast.current.show({
      severity: "info",
      summary: "Listados",
      detail: "Obteniendo información... !",
      life: 3000,
    });

    await obtenerCarteraAltas({
      vigencia,
      incluyeIntegrantes,
      todasLasEmpresas,
      grupo,
      empresaElegida,
      exportType,
      origen: "cartera",
      state,
    }).then((data) => {
      if (exportType === "excel") {
        elem = document.getElementById("expButtonExcel");
        elem.click();
      }
      if (exportType === "pdf") {
        elem = document.getElementById("expButtonPdf");
        elem.click();
      }
    });
    /*
    onHideFechas();
    setGrupo(null);
    guardarVigencia({
      desde: null,
      hasta: null,
    });
    setIncluyeIntegrantes(false);
    setTodasLasEmpresas(false);
    */
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Listados de Cartera de Afiliados",
      "No tiene permiso para acceder a esta pantalla !.",
      "error",
    );
    exitClick();
    return;
  };

  const renderHeaderFechas = () => {
    return (
      <div>
        <Tag value="Cartera de Afiliados"></Tag>
      </div>
    );
  };

  const renderFooterFechas = () => {
    return (
      <div>
        <button
          id="expButtonExcel"
          type="button"
          onClick={(e) => {
            exportExcel();
          }}
          style={{ visibility: "hidden" }}
        >
          Export Excel
        </button>
        <button
          id="expButtonPdf"
          type="button"
          onClick={(e) => {
            exportPdf();
          }}
          style={{ visibility: "hidden" }}
        >
          Export Pdf
        </button>

        <Button
          icon="pi pi-file-excel"
          onClick={(e) => {
            aceptarFechas("excel");
          }}
          className="p-button-raised p-button-success"
          data-pr-tooltip="XLS"
          label="Excel"
        />
        <Button
          icon="pi pi-file-pdf"
          onClick={(e) => {
            aceptarFechas("pdf");
            //exportPdf();
          }}
          className="p-button-raised p-button-warning"
          data-pr-tooltip="PDF"
          style={{ marginRight: "1em" }}
          label="PDF"
        />
        <ButtonMui
          onClick={onHideFechas}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  const fechaTemplate = (rowData) => {
    return <Fragment>{formatDate(rowData.fecha)}</Fragment>;
  };

  const anuladoTemplate = (rowData) => {
    return (
      <Fragment>
        <Checkbox checked={rowData.anulado}></Checkbox>
      </Fragment>
    );
  };

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(listadoExcel);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(excelBuffer, "carteraAfiliados");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      return new Promise((resolve) => {
        saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION,
        );
        resolve(true);
      });
    });
  };

  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        if (!grupo || grupo === "") {
          const doc = new jsPDF.default("l");
          doc.setFontSize(10);
          doc.text(
            `Listado de cartera de afiliados Desde: ${vigencia.desde} Hasta: ${
              vigencia.hasta
            } - incluye integrantes: ${
              incluyeIntegrantes ? "SI" : "NO"
            } - empresa: ${
              todasLasEmpresas ? "TODAS" : empresaElegida.nombre
            } `,
            60,
            8,
          );

          doc.autoTable(exportColumnsListado, listadoExcel, {
            styles: {
              fontSize: 6,
            },
            columnStyles: {
              11: {
                halign: "right",
              },
            },
          });
          window.open(doc.output("bloburl"));
          //doc.save("carteraAfiliados.pdf");
        } else {
          const doc = new jsPDF.default(0, 0);
          doc.setFontSize(10);
          doc.text(
            `Listado de cartera de afiliados agrupado por ${
              grupo.nombre
            } Desde: ${vigencia.desde} Hasta: ${vigencia.hasta} - empresa: ${
              todasLasEmpresas ? "TODAS" : empresaElegida.nombre
            } `,
            30,
            8,
          );
          doc.autoTable(exportColumnsAgrupado, listadoExcel, {
            styles: {
              fontSize: 10,
            },
            columnStyles: {
              1: {
                halign: "right",
              },
              2: {
                halign: "right",
              },
              3: {
                halign: "right",
              },
            },
            didParseCell: (data) => {
              if (data.cell && data.cell.section === "head") {
                switch (data.cell.raw) {
                  case "Grupos":
                  case "Cápitas":
                  case "Cuotas":
                    data.cell.styles.halign = "right";
                    break;
                  default:
                    data.cell.styles.halign = "left";
                    break;
                }
              }
              if (data.section === "body" && data.column.index === 3) {
                const valor = parseFloat(data.cell.raw);
                if (!isNaN(valor)) {
                  // Formato de moneda local (ej: $1,250.50)
                  data.cell.text = new Intl.NumberFormat("es-MX", {
                    style: "currency",
                    currency: "MXN",
                  }).format(valor);
                }
              }
            },
          });
          window.open(doc.output("bloburl"));
          //doc.save("carteraAfiliadosAgrupado.pdf");
        }
      });
    });
  };

  function formatDate(input) {
    var datePart = input.match(/\d+/g),
      year = datePart[0],
      month = datePart[1],
      day = datePart[2];
    return day + "/" + month + "/" + year;
  }

  function formatDateTime(dateString) {
    var allDate = dateString.replace("T", " ");
    allDate = allDate.replace(".", " ");
    allDate = allDate.split(" ");
    var thisDate = allDate[0].split("-");
    var thisTime = allDate[1].split(":");
    var newDate = [thisDate[2], thisDate[1], thisDate[0]].join("/");
    var newTime = [thisTime[0], thisTime[1]].join(":");
    return newDate + " " + newTime;
  }

  //console.log(state);
  //console.log(serviciosFinalizadosExcel);

  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Fragment>
          <Dialog
            header={renderHeaderFechas()}
            visible={visibleFechas}
            closable={false}
            footer={renderFooterFechas()}
            breakpoints={{ "960px": "75vw" }}
            style={{ width: "70vw", paddingBottom: "0" }}
            position="top"
          >
            <Grid container spacing={3} style={{ marginTop: "1vw" }}>
              <Grid item xs={12} md={4}>
                <label htmlFor="vigenciaDesde">Vigencia de Ingreso Desde</label>
                <InputMask
                  id="vigenciaDesde"
                  mask="99/99"
                  value={vigencia ? vigencia.desde : null}
                  placeholder="99/99"
                  //onBlur={handleEnter}
                  size={4}
                  onChange={(e) =>
                    guardarVigencia({
                      ...vigencia,
                      desde: e.value,
                    })
                  }
                  style={{ marginLeft: "0.7vw", marginTop: "0.4vw" }}
                ></InputMask>
              </Grid>

              <Grid item xs={12} md={4}>
                <label htmlFor="vigenciaHasta">Vigencia de Ingreso Hasta</label>
                <InputMask
                  id="vigenciaHasta"
                  mask="99/99"
                  value={vigencia ? vigencia.hasta : null}
                  placeholder="99/99"
                  //onBlur={handleEnter}
                  size={4}
                  onChange={(e) =>
                    guardarVigencia({
                      ...vigencia,
                      hasta: e.value,
                    })
                  }
                  style={{ marginLeft: "0.7vw", marginTop: "0.4vw" }}
                ></InputMask>
              </Grid>

              <Grid item xs={12} md={4} />

              <Grid
                item
                xs={12}
                md={5}
                style={{ marginLeftLeft: "1vw", marginTop: "0em" }}
              >
                <Autocomplete
                  id="agrupar"
                  fullWidth
                  options={agrupar}
                  disablePortal
                  getOptionLabel={(option) => option.nombre}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Agrupar por"
                      variant="standard"
                    />
                  )}
                  //onKeyDown={handleEnter}
                  onChange={(event, value) => {
                    if (value) {
                      setGrupo(value);
                    } else {
                      setGrupo(null);
                    }
                  }}
                />
              </Grid>

              <Grid
                item
                xs={6}
                md={3}
                style={{ marginLeft: "0.5vw", marginTop: "1vw" }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      style={{ marginLeft: "1vw", marginRight: "1vw" }}
                      inputId="incluyeIntegrantes"
                      onChange={(e) => {
                        setIncluyeIntegrantes(e.target.checked);
                      }}
                      checked={incluyeIntegrantes ? incluyeIntegrantes : false}
                    />
                  }
                  label="Incluye Integrantes"
                />
              </Grid>
              <Grid
                item
                xs={6}
                md={3}
                style={{ paddingLeft: "2vw", marginTop: "1vw" }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      style={{ marginLeft: "1vw", marginRight: "1vw" }}
                      inputId="todasLasEmpresas"
                      onChange={(e) => {
                        setTodasLasEmpresas(e.target.checked);
                      }}
                      checked={todasLasEmpresas ? todasLasEmpresas : false}
                    />
                  }
                  label="Todas Las Empresas"
                />
              </Grid>
            </Grid>
          </Dialog>
        </Fragment>
      ) : null}
      <Grid item xs={12} sm={12}></Grid>
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
